import React, { useState, useEffect, useRef } from 'react'
import { TextField, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, MenuItem, Card, CardMedia, CardActions, IconButton, Snackbar, Alert } from '@mui/material'
import { app, database, storage } from '../../../firebaseConfig'
import { doc, updateDoc, collection } from 'firebase/firestore'
import testImg from '../../../assets/testImg.png'
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import CloseIcon from '@mui/icons-material/Close'
import LoadingButton from '@mui/lab/LoadingButton'
import dateFormat, { masks } from "dateformat";
function EditService({ onClose, open, data, list }) {
    const id = data.id
    const [nom, setNom] = useState(data.nom_service)
    const [partie, setPartie] = useState(data.partie)
    const [description, setDescription] = useState(data.description_service)
    const [photo, setPhoto] = useState({})
    const [photoDisplay, setPhotoDisplay] = useState(data.image_service)
    const [errorData, setErrorData] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const lastImage = data.image_service
    const inputFileRef = useRef(null)
    const [loading,setLoading]=useState(false)
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorData(false)
    }
    const clickImage = (e) => {
        e.preventDefault()
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        let urlImage = lastImage
        setLoading(true)
        const listFilter = list.filter((elem) => {
            return elem.id !=id && elem.nom_service.toLowerCase() == nom.toLocaleLowerCase()
        })
        if(nom == '' && partie == '' && description == ''){
            setLoading(false)
            setErrorData(true)
            setErrorMessage('Veuillez remplir les champs obligatoire!')
            return 
        }
        if(listFilter.length>0){
            setLoading(false)
            setErrorData(true)
            setErrorMessage('Service existe déjà à notre base de données')
            return
        }
        if (photo.name) {
            urlImage = await uploadImage(photo)
        }
        const serviceDocRef = doc(database, 'service', id)
        try {
            await updateDoc(serviceDocRef, {
                nom_service: nom,
                description_service: description,
                partie: partie,
                image_service: urlImage
            })
            onClose()
            setLoading(false)
        } catch (err) {
            alert(err)
            setLoading(false)
        }
    }
    const uploadImage = (fileParm) => {
        const nom_img = "srv_img_"+dateFormat(new Date(),'yyyymmddHHMMss')
        return new Promise((resolve, reject) => {
            const storageRef = ref(storage, nom_img)
            const uploadTask = uploadBytesResumable(storageRef, fileParm)
            uploadTask.on('state_changed', (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
                (error) => {
                    console.log(error.message)
                    reject(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        resolve(downloadURL);
                    }).catch((error) => {
                        console.log(error.message);
                        reject(error);
                    });
                }
            )
        })

    }
    const changeImage = (e) => {
        const file = e.target.files[0]
        setPhoto(file)
        const reader = new FileReader();

        reader.onload = () => {
            setPhotoDisplay(reader.result);
        };

        reader.readAsDataURL(file);
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>Modification service</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Card sx={{ maxWidth: 200 }}>
                        <CardMedia
                            style={{ objectFit: 'contain', marginTop: 1, height: 100 }}
                            image={photoDisplay ? photoDisplay : testImg}
                            title="green iguana"
                        />
                        <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button size="small" onClick={clickImage}>Choisir une photo</Button>
                        </CardActions>
                    </Card>
                </div>
                <div>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="nom_service"
                        name="service"
                        label="Service"
                        fullWidth
                        onChange={(e) => {
                            setNom(e.target.value)
                        }}
                        value={nom}
                    />
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Partie"
                        defaultValue={partie}
                        fullWidth
                        onChange={(e) => {
                            setPartie(e.target.value)
                        }}
                    >
                        <MenuItem key="" value="">
                            Veuillez selectionner une partie
                        </MenuItem>
                        <MenuItem key="Tête" value="Tête">
                            Tête
                        </MenuItem>
                        <MenuItem key="Poitrine" value="Poitrine">
                            Poitrine
                        </MenuItem>
                        <MenuItem key="Ventre" value="Ventre">
                            Ventre
                        </MenuItem>
                        <MenuItem key="Main et pied" value="Main et pied">
                            Main et pied
                        </MenuItem>
                        <MenuItem key="Appareil Génital" value="Appareil Génital">
                            Appareil Génital
                        </MenuItem>
                        <MenuItem key="Particulier" value="Particulier">
                            Particulier
                        </MenuItem>
                    </TextField>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="description"
                        name="description"
                        label="Description"
                        fullWidth
                        onChange={(e) => {
                            setDescription(e.target.value)
                        }}
                        value={description}

                    />
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="Image"
                        name="image"
                        label="Image"
                        fullWidth
                        onChange={changeImage}
                        type='file'
                        style={{ display: 'none' }}
                        inputRef={inputFileRef}
                    />
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <LoadingButton variant='contained' color='success' loading={loading} loadingIndicator="Envoi...." onClick={handleSubmit}>Enregistrer</LoadingButton>
            </DialogActions>
            <Snackbar open={errorData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert
                    onClose={handleCloseAlert}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {errorMessage}
                </Alert>
            </Snackbar>
        </Dialog>
    )
}

export default EditService